module.exports = __webpack_public_path__ + "img/lengkapi-data-active.ecb1fff4.svg";